import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApi from "./useApi";
import { POKEMONGO_URL } from "../util/constants";
import PokemonGoProfileForm from "../interfaces/pokemonGoProfileForm";

const useEditPokemonGoProfile = (token: string, username: string) => {
    const { edit } = useApi(`${POKEMONGO_URL}/${token}`);

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (pokemonGoProfile: PokemonGoProfileForm) => edit(pokemonGoProfile),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [username]});
            queryClient.invalidateQueries({queryKey: ["users"]});
        }
    })
}

export default useEditPokemonGoProfile;